var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Headphones_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0356 12.3847C21.8775 9.75013 20.8707 7.24281 19.1669 5.33852C17.3024 3.2547 14.7483 2.05933 12.0581 2.05933C9.36788 2.05933 6.81371 3.2547 4.94924 5.33852C3.24667 7.24139 2.24012 9.74638 2.08091 12.3788C2.06629 12.4468 2.05859 12.5174 2.05859 12.5899V13.1176V16.8249C2.05859 17.3772 2.50631 17.8249 3.05859 17.8249V17.8819C3.05859 19.0513 4.00664 19.9994 5.17612 19.9994C6.34559 19.9994 7.29364 19.0513 7.29364 17.8819V13.6468C7.29364 12.4774 6.34559 11.5293 5.17612 11.5293C4.80139 11.5293 4.44941 11.6266 4.14406 11.7974C4.39694 9.85574 5.20211 8.05532 6.43972 6.67211C7.95071 4.98336 9.97464 4.05933 12.0581 4.05933C14.1415 4.05933 16.1654 4.98336 17.6764 6.67211C18.914 8.05535 19.7192 9.85583 19.9721 11.7975C19.6667 11.6267 19.3146 11.5293 18.9398 11.5293C17.7703 11.5293 16.8223 12.4774 16.8223 13.6468V17.8819C16.8223 19.0513 17.7703 19.9994 18.9398 19.9994C20.1093 19.9994 21.0573 19.0513 21.0573 17.8819V17.8249C21.6093 17.8245 22.0566 17.377 22.0566 16.8249V13.1602C22.0572 13.1461 22.0575 13.1319 22.0575 13.1176C22.0575 13.0682 22.0572 13.0189 22.0566 12.9695V12.5899C22.0566 12.5195 22.0494 12.4509 22.0356 12.3847Z",
    fill: "#A399B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsFill);
export default __webpack_public_path__ + "static/media/ContactUs_fill.bdb9c4cf67c32325809729395be6bdd1.svg";
export { ForwardRef as ReactComponent };